(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["hd-color-selector"] && !Shopify.designMode) return;
  try {
    (() => {
    const initialize = (scope = document) => {
      scope.querySelectorAll('[data-hd-colors]').forEach(picker => {
        if (picker.dataset.hdInitialized) return;
        picker.dataset.hdInitialized = 'true';
        const form = picker.closest('.product-form');
        const list = picker.querySelector('[data-hd-color-list]');
        const controls = picker.querySelector('[data-hd-color-controls]');
        const arrows = [...picker.querySelectorAll('[data-hd-color-scroll]')];
        const updateArrows = () => {
          const max = list.scrollWidth - list.clientWidth;
          controls.hidden = max < 2;
          arrows[0].disabled = list.scrollLeft < 2;
          arrows[1].disabled = list.scrollLeft >= max - 2;
        };
        arrows.forEach(button => button.addEventListener('click', () => {
          list.scrollBy({ left: Number(button.dataset.hdColorScroll) * list.clientWidth * .8, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
        }));
        list.addEventListener('scroll', updateArrows, { passive: true });
        const resizeObserver = new ResizeObserver(updateArrows);
        resizeObserver.observe(list);
        const selected = list.querySelector('[aria-current="true"]');
        if (selected) list.scrollLeft = Math.max(0, selected.offsetLeft - list.offsetLeft - (list.clientWidth - selected.clientWidth) / 2);
        const updateLinks = () => {
          const sizeIndex = picker.dataset.sizeIndex;
          const sizeSelector = form?.querySelector(`.option-selector[data-option-index="${sizeIndex}"]`);
          const size = sizeSelector?.querySelector('input:checked')?.value || sizeSelector?.querySelector('select')?.value;
          const previewId = new URL(location.href).searchParams.get('preview_theme_id');
          picker.querySelectorAll('[data-hd-color-link]').forEach(link => {
            const url = new URL(link.href, location.origin);
            if (size) {
              const variant = link.dataset.sizeVariants.split(';').map(entry => entry.split(':')).find(entry => entry[0] === size)?.[1];
              if (variant) url.searchParams.set('variant', variant);
              else url.searchParams.delete('variant');
            }
            if (previewId) url.searchParams.set('preview_theme_id', previewId);
            link.href = url.pathname + url.search;
          });
        };
        form?.addEventListener('change', updateLinks);
        picker.addEventListener('click', event => {
          const link = event.target.closest('[data-hd-color-link]');
          if (!link) return;
          if (link.getAttribute('aria-current') === 'true') {
            event.preventDefault();
            return;
          }
          updateLinks();
        });
        document.addEventListener('shopify:section:unload', event => {
          if (event.target.contains(picker)) resizeObserver.disconnect();
        });
        updateLinks();
        updateArrows();
      });
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize());
    else initialize();
    document.addEventListener('shopify:section:load', event => initialize(event.target));
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["hd-product-information"] && !Shopify.designMode) return;
  try {
    (() => {
    const initialize = (scope = document) => {
      scope.querySelectorAll('[data-hd-product-information]').forEach(info => {
        if (info.dataset.hdReady) return;
        info.dataset.hdReady = 'true';
        const destination = info.querySelector('[data-hd-size-tables]');
        const guide = info.querySelector('[data-hd-size-guide]');
        info.querySelectorAll('[data-hd-description] table').forEach(table => {
          if (table.rows.length > 2 && /waist|inseam|thigh|leg opening|rise|chest|shoulder/i.test(table.textContent)) destination.append(table);
        });
        if (destination.children.length) {
          guide.hidden = false;
          const productSection = info.closest('[data-section-type="main-product"]');
          productSection?.querySelectorAll('[data-hd-size-link]').forEach(link => { link.hidden = false; });
        }
      });
    };
    document.addEventListener('click', event => {
      const link = event.target.closest('[data-hd-size-link]');
      if (!link) return;
      const scope = link.closest('[data-section-type="main-product"]');
      const guide = scope?.querySelector('[data-hd-size-guide]');
      if (!guide || guide.hidden) return;
      event.preventDefault();
      guide.open = true;
      guide.scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth', block: 'center' });
      guide.querySelector('summary').focus({ preventScroll: true });
    });
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize());
    else initialize();
    document.addEventListener('shopify:section:load', event => initialize(event.target));
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["hd-store-reviews"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('hd-store-reviews')) {
    customElements.define('hd-store-reviews', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.track = this.querySelector('[data-review-track]');
        this.status = this.querySelector('[data-review-status]');
        this.previous = this.querySelector('[data-review-prev]');
        this.next = this.querySelector('[data-review-next]');
        this.retry = this.querySelector('[data-review-retry]');
        this.previous.addEventListener('click', () => this.move(-1));
        this.next.addEventListener('click', () => this.move(1));
        this.track.addEventListener('scroll', () => this.updateControls(), { passive: true });
        this.retry.addEventListener('click', () => this.load());
        this.resizeObserver = new ResizeObserver(() => this.updateControls());
        this.resizeObserver.observe(this.track);
        this.observer = new IntersectionObserver(entries => {
          if (entries.some(entry => entry.isIntersecting)) {
            this.observer.disconnect();
            this.load();
          }
        }, { rootMargin: '500px' });
        this.observer.observe(this);
      }
      disconnectedCallback() {
        this.observer?.disconnect();
        this.resizeObserver?.disconnect();
        this.controller?.abort();
        this.initialized = false;
      }
      text(value) {
        const decoder = document.createElement('textarea');
        decoder.innerHTML = String(value || '');
        return decoder.value;
      }
      element(tag, className, text) {
        const element = document.createElement(tag);
        element.className = className;
        if (text !== undefined) element.textContent = text;
        return element;
      }
      async load() {
        if (this.loading) return;
        this.loading = true;
        this.retry.hidden = true;
        this.status.hidden = false;
        this.status.textContent = this.dataset.loadingLabel;
        this.controller = new AbortController();
        const timeout = setTimeout(() => this.controller.abort(), 12000);
        try {
          const response = await fetch('https://api.yotpo.com/v1/widget/o8Py3DADCSNFX8fQ5Fddc4odyPHep2rqBNEmuCKz/products/yotpo_site_reviews/reviews.json?per_page=8&page=1', { signal:this.controller.signal, credentials:'omit' });
          if (!response.ok) throw new Error('Reviews unavailable');
          const payload = await response.json();
          const data = payload.response;
          const site = data?.products?.find(product => product.domain_key === 'yotpo_site_reviews');
          if (payload.status?.code !== 200 || !site || !Array.isArray(data.reviews)) throw new Error('Invalid reviews response');
          const reviews = data.reviews.filter(review => !review.deleted && review.product_id === site.id && Number.isInteger(review.score) && review.score >= 1 && review.score <= 5);
          if (!reviews.length) {
            this.status.textContent = this.dataset.emptyLabel;
            return;
          }
          const fragment = document.createDocumentFragment();
          const locale = document.documentElement.lang || 'en';
          for (const review of reviews) {
            const card = this.element('article', 'hd-store-reviews__card');
            card.dataset.reviewId = review.id;
            const stars = this.element('div', 'hd-store-reviews__stars', '★'.repeat(review.score) + '☆'.repeat(5-review.score));
            stars.setAttribute('role', 'img');
            stars.setAttribute('aria-label', this.dataset.ratingLabel.replace('[rating]', review.score));
            card.append(stars, this.element('blockquote', '', this.text(review.content)));
            const byline = this.element('div', 'hd-store-reviews__byline');
            byline.append(this.element('span', 'hd-store-reviews__author', this.text(review.user?.display_name)));
            if (review.verified_buyer) byline.append(this.element('span', 'hd-store-reviews__verified', '✓ ' + this.dataset.verifiedLabel));
            const date = new Date(review.created_at);
            if (!Number.isNaN(date.getTime())) {
              const time = this.element('time', 'hd-store-reviews__date', new Intl.DateTimeFormat(locale, { month:'short',day:'numeric',year:'numeric',timeZone:'UTC' }).format(date));
              time.dateTime = review.created_at;
              byline.append(time);
            }
            card.append(byline);
            fragment.append(card);
          }
          this.track.replaceChildren(fragment);
          const bottomline = data.bottomline;
          if (Number.isFinite(bottomline?.average_score) && Number.isFinite(bottomline?.total_review)) {
            this.querySelector('[data-review-summary]').textContent = this.dataset.summaryLabel.replace('[rating]', bottomline.average_score.toFixed(1)).replace('[count]', bottomline.total_review.toLocaleString(locale));
          }
          this.status.hidden = true;
          this.querySelector('[data-review-footer]').hidden = false;
          this.updateControls();
        } catch (error) {
          if (this.isConnected) {
            this.status.textContent = this.dataset.errorLabel;
            this.retry.hidden = false;
          }
        } finally {
          clearTimeout(timeout);
          this.loading = false;
        }
      }
      move(direction) {
        const card = this.track.firstElementChild;
        if (!card) return;
        const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
        const step = card.getBoundingClientRect().width + gap;
        const count = Math.max(1, Math.floor((this.track.clientWidth + gap) / step));
        const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.track.scrollBy({ left:direction*step*count, behavior:reducedMotion ? 'instant' : 'smooth' });
      }
      updateControls() {
        this.previous.disabled = this.track.scrollLeft <= 2;
        this.next.disabled = this.track.scrollLeft + this.track.clientWidth >= this.track.scrollWidth - 2;
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
